import React from 'react';
import PropTypes from 'prop-types';
import { Permissions } from '@upstart/harmony/lib/constants';
import { Confirm } from 'react-confirm-bootstrap';
import { MenuItem } from 'react-bootstrap/lib';
import withFeedPermission from './feedPermission';

function DeleteButton({ feedMapping, onDelete }) {
  return (
    <Confirm
      onConfirm={() => onDelete(feedMapping.id)}
      body={`Are you sure you want to delete ${feedMapping.type}?`}
      confirmText="Confirm Delete"
      title={`Deleting ${feedMapping.type}`}
    >
      <MenuItem>Delete</MenuItem>
    </Confirm>
  );
}

DeleteButton.propTypes = {
  feedMapping: PropTypes.object,
  onDelete: PropTypes.func,
};

export default withFeedPermission(Permissions.DELETE)(DeleteButton);
